import type { ComponentType } from 'react';
import { JsonRenderer } from 'react-scale/components/scalers/tasks/ThreadedInteraction/coding/experimental-code-block/components/json-renderer';

export const PrettyRenderComponents: {
  [key: string]: ComponentType<{
    className?: string;
    disableYScroll?: boolean;
    content: string;
  }>;
} = {
  json: JsonRenderer,
};
